module.exports = __webpack_public_path__ + "img/hand-holding-heart.1444f9e4.svg";